import React, { useState, useEffect, useRef } from "react";
import Message from "./Message";
import SendMessage from "./SendMessage";
import { db, auth } from "../../firebase";
import "./style.css";
import { useAuthState } from "react-firebase-hooks/auth";
import { ref, query, orderByChild, onValue, off, serverTimestamp, set, update } from "firebase/database";
import ApiService from "../../utils/Api";
import { GET_TRIPS } from "../../utils/Endpoint";
import Loader from "../loader";

const Chat = ({ booking, handleCloseChat, tripID }) => {
  const apikey = sessionStorage.getItem("key");
  const userid = sessionStorage.getItem("userid");
  const [user] = useAuthState(auth);
  const [messages, setMessages] = useState([]);
  const [tripDetail, setTripDetail] = useState({})
  const [show, setShow] = useState(true)
  const scroll = useRef();
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    getTripById(tripID)
  }, [tripID])

  useEffect(() => {
    if (!user || !tripID) {
      // console.log('No user or tripID, skipping listener');
      return; // Don't add listener if there's no user or tripID
    }

    // Reference to the Firebase messages for the specific trip
    const messagesRef = ref(db, 'Chats/' + tripID);
    const messagesQuery = query(messagesRef, orderByChild('timeStamp')); // Query to order by timestamp

    // console.log('Setting up Firebase listener for tripID:', tripID);

    // The function that is called whenever the data is updated
    const messagesListener = (snapshot) => {
      const messagesData = snapshot.val();
      if (messagesData) {
        const messagesArray = Object.keys(messagesData).map((key) => {
          const message = messagesData[key];

          // Mark as read if it's from a different user and unread
          if (message.from !== user?.uid && message?.is_read === false) {
            const messageRef = ref(db, `Chats/${tripID}/${key}`);
            update(messageRef, { is_read: true }); // Mark as read
          }

          return message;
        });
        setMessages(messagesArray);
        scroll.current?.scrollIntoView({ behavior: 'smooth' });
      } else {
        setMessages([]); // Reset if no messages found
      }
    };

    // Attach the listener to the Firebase reference
    onValue(messagesQuery, messagesListener);

    // Cleanup function: Unsubscribing from the Firebase listener
    return () => {
      // console.log('Cleaning up Firebase listener...');
      off(messagesQuery, 'value', messagesListener); // Unsubscribe from the listener
    };
  }, [user, tripID]); // When user or tripID changes, cleanup and add new listener


  const getTripIdForChatReference = (tripDetail) => {
    if (!tripDetail) {
      return null;
    }

    if (tripDetail.recurring_trip_id && tripDetail.recurring_trip_id !== "0") {
      return "r_" + tripDetail.recurring_trip_id;
    } else if (tripDetail.is_delivery === "1" && tripDetail.m_trip_id && tripDetail.m_trip_id !== "0") {
      return "d_" + tripDetail.m_trip_id;
    } else if (tripDetail.trip_id && tripDetail.trip_id !== "0") {
      return tripDetail.trip_id;
    }

    return null;
  }

  const createReferenceForTripChat = (tripId) => {
    if (!tripId || tripId.trim() === '') return;

    const userDate = JSON.parse(sessionStorage.getItem('auth'));
    if (!userDate) return;

    const userFireId = user.uid;
    const referenceChat = {
      // device_token: user.getUDeviceToken(),
      // device_type: user.getUDeviceType(),
      domery_user_id: userid,
      user_name: sessionStorage.getItem("name"),
      time: serverTimestamp(),
      user_id: userFireId,
      is_user: true,
      // profile_image: user.getDProfileImagePath(),
    };
    const tripRef = ref(db, `ref_TripChat/${tripId}/${userFireId}`);
    set(tripRef, referenceChat)
      .then(() => {
        console.log('Trip Reference sent successfully!');
      })
      .catch((error) => {
        console.error('Error sending message:', error);
      });
  }

  const getTripById = async (tripid) => {
    setLoader(true)
    try {
      const response = await ApiService.post(
        `${GET_TRIPS}?api_key=${apikey}&user_id=${userid}`, {
        trip_id: tripid
      }
      );
      if (response.status === 200) {
        if (response.data.response) {
          let value = response.data.response;
          if (Array.isArray(value) && value?.length > 0) {
            const tripValue = value[0]
            setTripDetail(tripValue)
            setupChatDetails(tripValue)
            setLoader(false)
          } else {
            setLoader(false)
          }
        }
      }
    } catch (error) {
      setLoader(false)
      console.log(`Trip Find Error`, error)
      console.log(`Trip Find Error`, error?.message)
      handleCloseChat()
    }
  }

  const setupChatDetails = (tripDetail) => {
    // console.log({ tripDetail })
    //// let tripIdForChatReference = getTripIdForChatReference(tripDetail);
    let tripIdForChatReference = tripDetail?.trip_id;
    if (!tripDetail || !tripDetail.trip_id || !tripIdForChatReference || !tripDetail?.Driver || !userid) {
      setShow(false)
      handleCloseChat()
      return;
    }

    let driver = tripDetail?.Driver;

    if (!tripDetail?.trip_status ||
      tripDetail?.trip_status?.toLowerCase() === "completed" ||
      tripDetail?.trip_status?.toLowerCase() === "cancel" ||
      tripDetail?.trip_status?.toLowerCase() === "expired") {
      setShow(false)
    } else {
      setShow(true)
    }

  }


  return (
    <main className="chat_container_main">
      {loader && <Loader classValue="loader_container_main_admin" />}
      <div className="chat_container_main_close">
        <i className="fas fa-times" onClick={handleCloseChat} />
      </div>
      <section className="chat_container_child">
        <article className="chat_container">
          {messages &&
            messages.map((message, i) => {
              const isLastMessage = i === messages?.length - 1;
              return <Message scrollBottomRef={isLastMessage ? scroll : null} key={message?.timeStamp} message={message} />
            })}
        </article>
        {/* Send Message Component */}
        {show && <SendMessage scroll={scroll} booking={booking} tripID={tripID} tripDetail={tripDetail} driverFireId={tripDetail?.Driver?.fire_id} />}
        <span ref={scroll}></span>
      </section>
    </main>
  );
};

export default Chat;
